import { Component, ElementRef, EventEmitter, Input, OnChanges, OnInit, Output, ViewChild } from '@angular/core';
import { AbstractControl, UntypedFormArray, NgForm } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { saveAs } from 'file-saver';
import { finalize } from 'rxjs/operators';
import { ToastService } from 'src/app/core';
import { CandidateApi, CandidateDocCombined, CandidateDocuments, DocumentConfigLookupMapping, DocumentInstructions, DocumentType, EmailApi, LookupField } from 'src/app/core/api.gen';
import { AuthService } from 'src/app/core/auth.service';
import { CommonService } from 'src/app/core/common.service';
import { DialogService } from 'src/app/core/dialog.service';
import { DocumentUploadService } from 'src/app/core/document-upload.service';
import { OpenFilePreviewService } from 'src/app/core/open-file-preview.service';
import { MethodValidityService } from 'src/app/immigration/services/validations/method-validity.service';
import { nullSafe } from 'src/app/utils';
import { Logger } from 'src/app/utils/Logger';
import { isNullOrUndefined } from '../../../app/core/utils';
import { LoaderService } from '../../core/loader.service';
import { ShareDocumentService } from '../../core/share-document.service';
import { GeneralMail } from '../configurable-mail/general-mail-model';
import { LookupFieldKeys } from '../lookup-fields-keys';
import { LookupTypeKeys } from '../lookup-type-keys';
import { AllowedDocumentFormat, DocumentValidationMessage, ModuleTypes, ValidationDocType } from '../module-types';
import { StatusTypes } from '../status-types';

@Component({
  selector: 'eos-file-upload',
  templateUrl: './document-upload.component.html',
  styleUrls: ['./file-upload.component.css']
})
export class FileUploadComponent implements OnInit, OnChanges {

  docnamePattern = "^[a-zA-Z0-9 ]*$";
  @Input() lookupType: number;
  @Input() readonly: boolean;
  @Input() country: number;
  @Input() candidateForm;
  @Input() pbProfile;
  @Input() cProfile;
  @Input() toolModule = 'RMT';
  @Input() allowDocCall = false;
  @Input() profileId = 0;
  @Input() showingFileUpload = false;
  @Input() flightBooking = false;
  @Input() uploadonly: boolean = false;
  @ViewChild('fileField') element: ElementRef;
  @ViewChild('fileControl') fileEle: ElementRef;

  @ViewChild('f') form: NgForm;
  requiredDocumentTypes: LookupField[] = [];
  documentTypes: LookupField[] = [];
  documentInstructions: DocumentInstructions[] = [];
  fileDetails: any;
  allFiles: CandidateDocCombined[] = [];
  gridFiles: CandidateDocCombined[] = [];
  selectedDocument: File;
  disableUpload = false;
  editMode = false;
  showUpload = true;
  docName: string;
  docInstruction: string;
  showSpinner = false;
  docType: string;
  documentList: DocumentType[];
  distinctDocTypes: DocumentType[];
  docsForDocTypes: DocumentType[];
  showDocName = false;
  emailShare: GeneralMail = new GeneralMail();
  attachmentShared = [];
  checkDocType: number;
  TMT_Check_Status: string;
  validationList: DocumentValidationMessage[] = [];
  isCollapsed= false;
  uploadedCount: number = 0;
  pendingCount: number = 0;
  pendingAllCount: number = 0;
  totalCount: number = 0;
  selectedTab: number = 1;
  allDoc: boolean = false;
  uploadedDoc: boolean = false;
  pendingDoc: boolean = false;
  isMandatoryChecked: boolean = false;

  readonly allowedMineTypes = [
    'application/pdf'
    , 'image/jpeg'
    , 'image/png'
    , 'application/msword'
    , 'application/vnd.openxmlformats-officedocument.wordprocessingml.document'
    , 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
    , 'application/vnd.ms-excel'
  ];

  readonly MAX_FILE_SIZE: number = 10 * 1024 * 1024;
  readonly MIN_FILE_SIZE: number = 1 * 1024;

  @Output() GetDocumentEvent = new EventEmitter<CandidateDocCombined[]>();
 // @Output() GetDocList = new EventEmitter<CandidateDocCombined[]>();

  constructor(
    private common: CommonService,
    private fileUploadService: DocumentUploadService,
    private candidateApi: CandidateApi,
    private route: ActivatedRoute,
    private toast: ToastService,
    public authService: AuthService,
    private dialog: DialogService,
    private validations: MethodValidityService,
    private openfilepreview: OpenFilePreviewService,
    private emailAPI: EmailApi,
    public modal: NgbActiveModal,
    private loader: LoaderService,
    private shareDocService: ShareDocumentService
  ) {
    this.fileDetails = new CandidateDocCombined();
    this.fileDetails.documentTypeId = null;
    this.fileDetails.documentId = null;
    this.fileDetails.documentName = '';
  }

  ngOnInit() {
    if (this.lookupType === LookupTypeKeys.RECRUITMENT_DOCUMENT_TYPES) {
      this.docType = "Download recruitment documents";
    } else {
      this.docType = "Download all";
    }

    this.route.params.subscribe(data => {
      if (data.id && data.id > 0) {
        this.common.candidateId = data.id;
        //this.getUploadedFileDetails(data.id);
        this.getCandidateDocuments();
        this.GetDocumentEvent.emit(this.uploadedFiles);
      }
    });  
  }

  multipleDocsShare() {
    //if (this.lookupType == LookupTypeKeys.RECRUITMENT_DOCUMENT_TYPES) {
      this.attachmentShared = this.shareDocService.changeDocumentName(this.allFiles.filter(x => x.isUploaded), ModuleTypes.Preboarding);
      if (!this.shareDocService.isFileAvailable(this.attachmentShared)) {
        return;
      }
      this.multiDocShareFn();
    //} 
    // else {
    //   this.candidateApi.getCandidateDocsDetails(this.common.candidateId)
    //     .subscribe(resp => {          
    //       resp = this.shareDocService.changeDocumentName(this.allFiles.filter(x => x.isUploaded), ModuleTypes.Preboarding);
    //       this.attachmentShared = resp;
    //       if (!this.shareDocService.isFileAvailable(resp)) {
    //         return;
    //       }
    //       this.multiDocShareFn();
    //     });
    // }
  }
  mandatoryCheck() {
   this.isMandatoryChecked = !this.isMandatoryChecked;
    this.getfileGrid(this.selectedTab);
  }

  
 
  getfileGrid(type: number) {

    //if (!this.isAdditionalUpload) {
      this.selectedTab = 1;
      this.gridFiles = this.isMandatoryChecked?this.allFiles.filter(x => x.isMandatory):this.allFiles;

      this.allDoc = true;
      this.uploadedDoc = false;
      this.pendingDoc = false;

      if (type == 2) {
        this.selectedTab = 2;
        this.gridFiles = this.isMandatoryChecked?this.allFiles.filter(x => x.isMandatory && x.isUploaded):this.allFiles.filter(x => x.isUploaded);
        this.allDoc = false;
        this.uploadedDoc = true;
        this.pendingDoc = false;
      } else if (type == 3) {
        this.selectedTab = 3;
        this.gridFiles = this.isMandatoryChecked?this.allFiles.filter(x => x.isMandatory && !x.isUploaded):this.allFiles.filter(x => !x.isUploaded);
        this.allDoc = false;
        this.uploadedDoc = false;
        this.pendingDoc = true;

      }
    // }
    // else {
    //   this.gridFiles = this.allFiles.filter(x => x.additionalReqId != null && x.additionalReqId != 0);
    // }

  }

  multiDocShareFn() {
    this.loader.show();
    this.emailAPI.getRenderedMail(this.common.candidateId, "ShareDocument-PJ",0).pipe(finalize(() => {
      this.loader.clear();
    })).subscribe(em => {
      this.emailShare = this.shareDocService.mapToGeneralMail(em);
      this.emailShare.uploadedFiles = [];
      this.dialog.docShareMail(this.emailShare, (email) => {
        email.activityTemplateId = em.activityTemplateId;
        this.shareDocService.confirmModal(email, ModuleTypes.Preboarding);
      }, "Share Documents", ModuleTypes.Preboarding, false, this.attachmentShared);
    });
  }

  share(details: CandidateDocCombined) {
    this.loader.show();
    this.attachmentShared = [];
    const dName = details.fileName.split(".");
    details.fileName = details.documentName.replace("GPN_", '') + "." + dName[dName.length - 1];
    this.attachmentShared.push(details);
    this.emailAPI.getRenderedMail(details.candidateProfileId, "ShareDocument-PJ",0).pipe(finalize(() => {
      this.loader.clear();
    })).subscribe(em => {
      this.emailShare = this.shareDocService.mapToGeneralMail(em);
      this.emailShare.subject = "Document: " + details.documentTypeName;
      this.emailShare.uploadedFiles = this.attachmentShared;
      this.dialog.docShareMail(this.emailShare, (email) => {
        email.activityTemplateId = em.activityTemplateId;
        this.shareDocService.confirmModal(email, ModuleTypes.Preboarding);
      }, "Share Documents", ModuleTypes.Preboarding, true);
    });
  }

  ngOnChanges() {
    if (this.profileId > 0
      && this.showingFileUpload) {
      // this.getDocumentTypes();
      // this.getDocumentInstructions();
      this.getCandidateDocuments();
      this.validationList = [];
    }
    //this.getProfileDocuments();
  }

  getUploadedFileDetails(id: number) {
    this.candidateApi.getCandidateDocsDetails(id).subscribe(resp => {
      this.allFiles = resp;
      this.GetDocumentEvent.emit(this.uploadedFiles);
    });
  }


  get uploadedFiles(): Array<CandidateDocuments> {
    const res = this.allFiles.filter(x =>
      x.moduleType === this.lookupType
    );


    return res;
  }

  getDocName(docName: string) {
    let docC=this.cProfile?.docPrefix;
    if (!docC) {
      return docName.replace("GPN_", '');
    }
    let docN = docName && docName.indexOf("GPN_") > -1 ?
      docName.replace("GPN", docC) : `${docC}_${docName}`
    return docN;
  }

  get ifDocNotValid(): boolean {
    if (this.selectedDocument && (this.selectedDocument.size < this.MIN_FILE_SIZE || this.selectedDocument.size > this.MAX_FILE_SIZE)) {
      return true;
    }

    return false;
  }

  get isRecruitment(): boolean {
    return this.common.isRecruitment;
  }

  get isUploadRequired(): boolean {
    return (this.uploadonly && !this.isRecruitment && this.showingFileUpload);
  }


  browseFile(doc) {
    this.fileDetails.id = doc.id;
    this.fileDetails.documentTypeId = doc.documentTypeId;
    this.fileDetails.documentId = doc.documentNameId;
    this.fileDetails.documentName = doc.description == null ? '' : doc.description
    this.fileDetails.fileName = doc.fileName;
    this.fileDetails.fileGuiId = doc.fileGuiId;
    this.fileDetails.candidateProfileId = this.profileId;
    this.fileDetails.createdById = doc.createdById;
    this.fileDetails.moduleType = doc.moduleType;
    this.fileDetails.checks = doc.checks;   
    if (this.fileDetails.checks) {
      this.checkDocType = JSON.parse(this.fileDetails.checks)[0].Type;
      this.TMT_Check_Status = JSON.parse(this.fileDetails.checks)[0].Tmt_Check_Status;
    }
    else
    {
      this.checkDocType = 0;
      this.TMT_Check_Status = null;
    }
    // Update file input accept attribute to reflect new allowed types
    if (this.fileEle && this.fileEle.nativeElement) {
      this.fileEle.nativeElement.accept = this.fileBrowserAllowedTypes;
    }
    this.fileEle.nativeElement.click();
  }

  // getDocumentTypes() {
  //   this.form.resetForm();
  //   this.fileDetails.documentName = '';
  //   this.candidateApi.getRequiredDocuments(this.toolModule,this.flightBooking,this.cProfile)
  //     .subscribe(resp => {
  //       this.documentList = resp;
  //       this.GetDocList.emit(this.documentList);
  //     });
  // }
  getCandidateDocuments() {   
    this.fileDetails.documentName = '';
    this.cProfile.id =  this.common.candidateId;   
    this.candidateApi.getCandidateDocuments(this.toolModule,this.flightBooking,this.cProfile)
      .subscribe(resp => {        
        this.allFiles = resp;
        this.uploadedCount = this.allFiles.filter(x => x.isUploaded).length;
        this.pendingAllCount = this.allFiles.length - (this.allFiles.filter(x => x.isUploaded).length);
        this.pendingCount = (this.allFiles.filter(x => x.isMandatory).length) - (this.allFiles.filter(x => x.isMandatory && x.isUploaded).length);
        this.totalCount = this.allFiles.length;
        this.gridFiles = this.allFiles;
        this.getfileGrid(1);
        this.GetDocumentEvent.emit(resp);
      });
  }
  getDocumentInstructions() {
    this.docInstruction = null;
    this.candidateApi.getPJDocumentInstructions(this.cProfile)
      .subscribe(resp => {
        this.documentInstructions = resp;
      });
  }

  get getdistinctDocTypes(): DocumentType[] {
    this.distinctDocTypes = [];
    if (this.documentList && this.documentList.length > 0) {
      this.distinctDocTypes = this.documentList.filter(
        (docType, i, arr) => arr.findIndex(t => t.docTypeId === docType.docTypeId) === i);
    }
    return this.distinctDocTypes;
  }

  setCMDocTypes() {
    this.fileDetails.documentId = null;
    this.docInstruction = null;
    this.validationList = [];
    this.checkDocType=0
    this.docsForDocTypes = this.documentList ? this.documentList.filter(t => t.docTypeId == this.fileDetails.documentTypeId) : [];
    if (this.docsForDocTypes.length === 1) {
      this.fileDetails.documentId = this.docsForDocTypes[0].docNameId;
      this.setCMDocInstruction();
    }
  }

  setCMDocInstruction() {
    this.docInstruction = null;
    this.docInstruction = nullSafe(() => this.documentInstructions.filter(t => t.docNameId === parseInt(this.fileDetails.documentId.toString()))[0].documentInstruction, '');
    this.fileDetails.checks = nullSafe(() =>
      this.docsForDocTypes.find(dt => dt.docNameId == this.fileDetails.documentId).checks, "");
    if (this.fileDetails.checks) {
      this.checkDocType = JSON.parse(this.fileDetails.checks)[0].Type;
      this.TMT_Check_Status = JSON.parse(this.fileDetails.checks)[0].Tmt_Check_Status;
    }


  }

  get filteredDocType(): LookupField[] {
    this.documentTypes = this.documentTypes.filter(f => {
      return f.parentFieldId === this.country || f.parentFieldId === null;
    });
    this.requiredDocumentTypes = this.validateuploadedfiles();
    return this.documentTypes;
  }

  setDocumentName(event) {
    this.fileDetails.documentName =
      this.docsForDocTypes.find(dt => dt.docNameId == this.fileDetails.documentId).docNameDisplayText;
  }

  setMandatory(doctypeId) {
    return this.documentList.filter(x => x.docTypeId === doctypeId && (x.isMandatory || x.mandatoryType > 0)).length > 0
  }

  get fileBrowserAllowedTypes() {

    switch (this.checkDocType) {
      case ValidationDocType.ImageDocument:
        return AllowedDocumentFormat.allowedImageMineTypes.join(',');
      case ValidationDocType.PDFDocument:
        return AllowedDocumentFormat.allowedDocumentMineTypes.join(',');

      default:
        return this.allowedMineTypes.join(',');
    }
  }


  isRequiedDocumentType(docTypeId: number) {
    if (this.lookupType === LookupTypeKeys.PREBOARDING_DOCUMENT_TYPES) {
      return false;
    }
    let c = this.requiredDocumentTypes.some(o2 => o2.id === docTypeId);
    return c;
  }

  fileSelected(files: FileList) {
    if (!files.item(0)) {
      return;
    }
    this.selectedDocument = files.item(0);

    if (this.selectedDocument.size < this.MIN_FILE_SIZE || this.selectedDocument.size > this.MAX_FILE_SIZE) {
      this.toast.error(`Invalid file size. File size should be between ${(this.MIN_FILE_SIZE / 1024).toFixed()} KB and ${(this.MAX_FILE_SIZE / 1024 / 1024).toFixed()} MB`);
      this.fileEle.nativeElement.value = null;
      return;
    }
    if (this.checkDocType == ValidationDocType.ImageDocument &&
      AllowedDocumentFormat.allowedImageMineTypes.indexOf(this.selectedDocument.type) < 0 ||
      this.checkDocType == ValidationDocType.PDFDocument &&
      AllowedDocumentFormat.allowedDocumentMineTypes.indexOf(this.selectedDocument.type) < 0 ||
      this.allowedMineTypes.indexOf(this.selectedDocument.type) < 0) {
      this.toast.error(`Invalid file type. Please select a valid file`);
      this.fileEle.nativeElement.value = null;
      this.selectedDocument = null;
      this.element.nativeElement.value = "";
      return;
    }

    this.fileDetails.fileName = this.selectedDocument.name;

    if (this.fileDetails.checks) {
      this.checkDocType = JSON.parse(this.fileDetails.checks)[0].Type;
      this.TMT_Check_Status = JSON.parse(this.fileDetails.checks)[0].Tmt_Check_Status;
    }

    this.uploadDoc();
  }

  get selectedFileName(): string {
    return nullSafe(() => this.selectedDocument.name, '');
  }


  uploadDoc() {
    if (this.ifDocNotValid) {
      this.toast.error(`Invalid file size. File size should be between ${(this.MIN_FILE_SIZE / 1024).toFixed()} KB and ${(this.MAX_FILE_SIZE / 1024 / 1024).toFixed()} MB`);
      return;
    }
    if (!this.editMode && isNullOrUndefined(this.selectedDocument)) {
      this.toast.warning("Please select a file!");
      return;
    }


    if (!this.editMode) {
      this.fileDetails.id = -1;
      this.fileDetails.createdById = this.authService.ActiveUser.employeeId;
    } else {
      this.fileDetails.modifiedById = this.authService.ActiveUser.employeeId;
    }

    this.upload();
  }

  upload() {
    this.validationList = [];
    this.fileDetails.candidateProfileId = this.profileId;
    this.fileDetails.moduleType = this.lookupType;    
    this.disableUpload = true;
    this.loader.show();
    this.fileUploadService.postFile(this.fileDetails, this.TMT_Check_Status, this.selectedDocument).pipe(finalize(() => {
      this.disableUpload = false;
    }))
      .subscribe(resp => {
        this.validationList = this.getDocValidationMessages(nullSafe(() => resp.data.documentChecks,[]));
        if (resp.errorCode === 6001) {
          this.toast.error("File upload failed due to not meeting specifications!");
          //return
          this.loader.clear();
        }
        else
        {  
        this.uploadReponse(resp)
        this.loader.clear();
        }
      }, error => {
        this.loader.clear();
        this.toast.error("Something went wrong!");
      });
    this.GetDocumentEvent.emit(this.allFiles);
  }
  uploadReponse(resp) {
    if (this.selectedDocument) {
      this.toast.success("File uploaded successfully!");
    } else {
      this.toast.success("Document details updated successfully!");
    }
    this.getCandidateDocuments();
  }

  getDocValidationMessages(errorList: DocumentConfigLookupMapping[]) {
    let messages: DocumentValidationMessage[] = [];
    if(!errorList){
      return [];
     } 
    errorList.forEach(x => {
      if (x.isStrict) {
        const error: DocumentValidationMessage = {
          errorMessage: x.errorMessage,
          errorType: "Fail",
        };

        messages.push(error);
      }
      else {
        const error: DocumentValidationMessage = {
          errorMessage: x.errorMessage,
          errorType: "Warning",
        };

        messages.push(error);
      }
    });

    return messages;
  }

  updateAllFiles(resp: CandidateDocuments) {
    resp.documentType.lookupTypeId = this.lookupType;
    if (this.editMode) {
      this.allFiles.splice(this.allFiles.findIndex(file => file.id === resp.id), 1, resp);
    } else {
      this.allFiles.push(resp);
    }
  }

  clear(f: NgForm) {
   
  this.clearFormAndValidations(f);
  }

  clearFormAndValidations(f: NgForm, clearValidation :boolean =true){
    f.resetForm();
    this.fileDetails.init({ documentTypeId: null, documentId: null, documentName: '' });
    this.selectedDocument = null;
    this.fileEle.nativeElement.value = null;
    this.editMode = false;
    this.docInstruction = null;
    if(clearValidation){
      this.validationList = [];
    }
  
  }

  findControl(farr: UntypedFormArray, path: string): AbstractControl {
    const emptyarr: Array<AbstractControl> = [];
    const forms = nullSafe(() => farr.controls, emptyarr);
    for (const fc of forms) {
      const ctrl = fc.get(path);
      if (ctrl) {
        return ctrl;
      }
    }
    return null;
  }
  downloadDocument(details: CandidateDocuments) {
    details.candidateProfileId=this.profileId;
    const fname = nullSafe(() => this.findControl(this.candidateForm, 'firstName').value, 'firstName');
    const lname = nullSafe(() => this.findControl(this.candidateForm, 'lastName').value, 'lastName');

    const filename = `${fname}_${lname}`;
    this.fileUploadService.downloadFile(details, filename).subscribe(resp => {
      const extension = this.common.getFileExtension(details.fileName);
      const docName = this.getDocName(details.documentName);
      saveAs(resp, `${docName}${extension}`);
    },
      error => {
        Logger.error(error);
      });
  }

  downloadAll() {

    let module = null;

    if (this.showSpinner) {
      return;
    }
    if (this.allFiles.filter(x => x.isUploaded).length <= 0 && this.lookupType === LookupTypeKeys.RECRUITMENT_DOCUMENT_TYPES) {
      this.toast.warning("No files to download!");
      return;
    }
    if (this.lookupType === LookupTypeKeys.RECRUITMENT_DOCUMENT_TYPES) {
      module = this.toolModule;
    }
    this.showSpinner = true;
    this.fileUploadService.downloadAll(this.profileId, module).pipe(finalize(() => {
      this.showSpinner = false;
    })).subscribe(resp => {
      const preFix = this.cProfile.docPrefix ? `${this.cProfile.docPrefix}_` : '';
      const fname = nullSafe(() => this.findControl(this.candidateForm, 'firstName').value, 'firstName');
      const lname = nullSafe(() => this.findControl(this.candidateForm, 'lastName').value, 'lastName');
      const filename = `${preFix}${fname}_${lname}`;
      saveAs(resp, `${filename}.zip`);
    }, err => {
      Logger.error(err);
    });
  }

  edit(fileDetails) {
    let index = this.allFiles.findIndex(file => file.id === fileDetails.id);
    this.allFiles[index].isEditMode = true;
    this.editMode = true;
    this.fileDetails.id = fileDetails.id;
    this.fileDetails.documentName = fileDetails.documentName;
    this.fileDetails.documentTypeId = fileDetails.documentTypeId;
    //this.setCMDocTypes();
    this.fileDetails.fileName = fileDetails.fileName;
    this.fileDetails.fileGuiId = fileDetails.fileGuiId;
    this.fileDetails.candidateProfileId = this.profileId;
    this.fileDetails.createdById = fileDetails.createdById;
    this.fileDetails.documentId = fileDetails.documentNameId;
    this.fileDetails.moduleType = fileDetails.moduleType;
    this.fileDetails.checks = fileDetails.checks;
    this.checkDocType = 0;
    //this.setCMDocInstruction();
  }

  delete(fileDetails) {
    fileDetails.candidateProfileId = this.profileId;
    this.dialog.showConfirmationBox('Confirm delete',
      'Are you sure you want to delete this file?',
      () => {
        this.candidateApi.deleteFile(fileDetails).subscribe((resp) => {
          if (resp) {
            this.toast.success("Document deleted!");
          } else {
            this.toast.error("Document deletion failed!");
          }
          this.getCandidateDocuments();
        });
      });

  }


  preview(details: CandidateDocuments) {
    this.openfilepreview.getFilePreviewToken(details).then(token => {
      this.tryOpenInNativeApp(token, details);
    }).catch(err => {
      Logger.error(err);
    });
  }

  tryOpenInNativeApp(token: string, details: CandidateDocuments) {
    const extension: string = details.fileName.split('.').pop();
    this.docName = `${details.documentName}.${extension}`;

    this.openfilepreview.previewFile(token, details.fileGuiId, this.docName).catch(r => {
      if (extension.toLowerCase() === 'pdf') {
        this.previewPDFFile(token, details);
      } else if (['png', 'jpg', 'jpeg'].indexOf(extension.toLowerCase()) > -1) {
        this.previewImageFile(token, details);
      }
    });
  }

  replaceGPNwithCode(docName:string){
    let docN = docName && docName.indexOf("GPN_") > -1 ?
      docName.replace("GPN", "CC+GUI") : `${"CC+GUI"}_${docName}`
    return docN;
  }
  previewPDFFile(token: string, details: CandidateDocuments) {
    this.dialog.showPDFPreviewiew(this.openfilepreview.constructPDFUrl(token, this.docName), this.docName);
    // window.open(this.openfilepreview.constructPDFUrl(token, this.docName), '_blank');
  }

  previewImageFile(token: string, details: CandidateDocuments) {
    this.dialog.showImagePreview(this.openfilepreview.constructPDFUrl(token, this.docName), this.docName);
    // window.open(this.openfilepreview.constructPDFUrl(token, this.docName), '_blank');
  }

  private validateuploadedfiles() {
    if (this.isRecruitment) {
      this.requiredDocumentTypes = this.documentTypes;
      this.requiredDocumentTypes = this.requiredDocumentTypes
        .filter(item => item.id !== LookupFieldKeys.Miscellenious);

      this.requiredDocumentTypes = this.requiredDocumentTypes
        .filter(item => item.id !== LookupFieldKeys.Manama_visa_offer);

      if (!isNullOrUndefined(this.candidateForm.value[0].onboardingType)) {
        if (this.candidateForm.value[0].onboardingType.id !== LookupFieldKeys.National) {
          this.requiredDocumentTypes = this.requiredDocumentTypes.filter(item => item.id !== LookupFieldKeys.National_ID);
        }
      }
      if (!isNullOrUndefined(this.candidateForm.value[0].employeeCategory)) {
        if (this.candidateForm.value[0].employeeCategory.id === LookupFieldKeys.Internal_transfer) {
          const ids = [LookupFieldKeys.Change_of_Term, LookupFieldKeys.Job_description, LookupFieldKeys.Passport_Copy, LookupFieldKeys.Internal_Trans_Form];
          this.requiredDocumentTypes = this.requiredDocumentTypes.filter(item => ids.indexOf(item.id) !== -1);
        } else if (this.candidateForm.value[0].employeeCategory.id !== LookupFieldKeys.Internal_transfer) {
          this.requiredDocumentTypes = this.requiredDocumentTypes.filter(item => item.id !== LookupFieldKeys.Internal_Trans_Form);
        }
      }
    } else if (!this.isRecruitment) {
      this.requiredDocumentTypes = [];
    }
    return this.requiredDocumentTypes;
  }

  closeEdit(fileDetails) {
    let index = this.allFiles.findIndex(file => file.id === fileDetails.id);
    this.allFiles[index].isEditMode = false;
    this.editMode = false;
  }

  AdditionalDocReq() {
    this.dialog.CandidateAdditionalDocReq(this.cProfile,(reqList) => {
      this.dialog.showConfirmationBox(
        "Confirm send mail"
        ,`This will send a mail to candidate on '${ this.cProfile.emailID }' requesting documents from gateway portal
      . Do you really want to continue?`,
        () => {
       this.loader.show();
        this.candidateApi.requestCandiateDocuments(this.cProfile.id, reqList).pipe((finalize(() => {
        this.loader.clear();
      }))).subscribe(resp => {
        this.toast.success("Request send successfully");
      }, err => {
        this.toast.error("An error ocurred");
      });
      this.modal.close();
      });
    },)}
 
    
 

  get isDocRequestable() {

    return !this.isRecruitment && (([StatusTypes.APPROVED, StatusTypes.INPROCESS].includes(this.pbProfile.pbStatusID) && this.lookupType !== LookupTypeKeys.RECRUITMENT_DOCUMENT_TYPES) || this.pbProfile.pbStatusID == StatusTypes.PENDING);

  }
}
